<template>
  <div>
    <div class="filter-search">
      <el-input
        placeholder="发放名称"
        size="medium"
        v-model.trim="searchParam.issueName"
        clearable
        @keyup.native.enter="search"
      ></el-input>
      <el-select
        clearable
        placeholder="场景"
        size="medium"
        v-model="searchParam.scene"
      >
        <el-option
          :key="item.sceneValue"
          :label="item.sceneName"
          :value="item.sceneValue"
          v-for="item in SceneList"
        ></el-option>
      </el-select>
    </div>
    <div class="option-button">
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-search"
        @click.native="search"
        >搜索
      </el-button>
      <el-button type="danger" size="medium" @click.native="newOpenAdvDialog"
        >新增
      </el-button>
    </div>
    <div class="table-container">
      <el-table
        size="mini"
        v-loading="loading"
        :data="tableData"
        :header-cell-style="{ background: '#fdfdfd' }"
        :height="460"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column
          key="issueName"
          prop="issueName"
          align="center"
          label="发放名称"
          width="250"
        ></el-table-column>
        <el-table-column
          key="scene"
          prop="scene"
          align="center"
          label="适用平台"
          width="80"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.source == 1">秒得</span>
            <span v-if="scope.row.source == 2">智租侠</span>
          </template>
        </el-table-column>
        <el-table-column
          key="scene"
          prop="scene"
          align="center"
          label="场景"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.scene == 'register'">用户注册 </span>
            <span v-else>通用场景</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="时间限制" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.startTime }} - {{ scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          key="status"
          align="center"
          label="启用该状态"
          width="150"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status">启用</span>
            <span v-else>禁用 </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click.native="editTable(scope.row)"
              >修改
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="doCopy(scope.row.couponNo)"
              >复制领券地址
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchParam.pageNum"
        :page-sizes="[5, 10, 15]"
        :page-size="searchParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :title="newDate.couponNo ? '编辑场景' : '新增场景'"
      top="50px"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showNewDialog"
      @close="closeNewDialog"
    >
      <el-form
        ref="newDate"
        :rules="newRuler"
        :model="newDate"
        :hide-required-asterisk="false"
      >
        <el-form-item label="发放名称" prop="issueName" label-width="120px">
          <el-input
            v-model.trim="newDate.issueName"
            size="medium"
            style="width:200px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="适用平台" label-width="120px" prop="source">
          <el-select
            clearable
            size="medium"
            style="width:200px"
            v-model="newDate.source"
            @change="changeSource"
          >
            <el-option
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-for="item in sourceList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择场景" label-width="120px" prop="scene">
          <el-select
            v-model="newDate.scene"
            style="width:200px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in SceneList"
              :key="item.sceneValue"
              :label="item.sceneName"
              :value="item.sceneValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间限制" label-width="120px">
          <el-date-picker
            v-model="NewdataPicker"
            size="medium"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="启用状态" label-width="120px">
          <el-radio-group v-model="newDate.status">
            <el-radio :label="true">启用</el-radio>
            <el-radio :label="false">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择优惠券" label-width="120px">
          <el-select
            v-model="coupons"
            style="width:300px"
            filterable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in allCouponList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showNewDialog = false"
          >取 消
        </el-button>
        <el-button type="primary" size="small" @click="sureAddEdit()"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coupons: [], //新增修改选择的优惠券id集
      showNewDialog: false,
      NewdataPicker: [], //新增修改时间选择
      // 搜索参数
      searchParam: {
        pageNum: 1,
        pageSize: 5,
        issueName: "",
        scene: "",
      },
      total: "",
      tableData: [],
      SceneList: [],
      allCouponList: [], //全部优惠券list
      newDate: {
        couponNo: "", //场景Id
        issueName: "", //场景名称
        scene: "", //场景类别
        startTime: "",
        endTime: "",
        status: true, //状态
        coupons: "", //绑定的优惠券为JSON格式[{name:yhy，id:1}]
      },
      sourceList: [
        { value: 1, label: "秒得" },
        { value: 2, label: "智租侠" },
      ], //产品类型
    };
  },
  computed: {},
  created() {
    this.getSceneSelect(); //获取下拉场景
    this.search();
    this.getAllCoupon();
  },
  methods: {
    doCopy(couponNo) {
      var Url = axios.defaults.copyUrl + couponNo;
      this.$copyText(Url).then(
        (e) => {
          // success
          this.$message({
            message: "复制成功!",
            type: "success",
          });
        },
        (e) => {
          // fail
          console.log(e);
        }
      );
    },
    // 执行搜索
    search() {
      this.searchParam.pageNum = 1;
      this.getSceneList();
    },
    // 获取优惠券
    async getAllCoupon() {
      try {
        this.loading = true;
        let res = await couponApi.getAllCoupon({ source: this.newDate.source });
        this.loading = false;
        if (res.code == "200") {
          this.allCouponList = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;
        handleError(error);
      }
    },
    async getSceneSelect() {
      try {
        this.loading = true;
        let res = await couponApi.getSceneSelect("");
        this.loading = false;
        if (res.code == "200") {
          this.SceneList = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;
        handleError(error);
      }
    },
    async getSceneList() {
      try {
        this.loading = true;
        let res = await couponApi.getSceneList(this.searchParam);
        this.loading = false;
        if (res.code == "200") {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;
        handleError(error);
      }
    },
    // 每页页数变化
    handleSizeChange(val) {
      this.searchParam.pageSize = val;
      this.getSceneList();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.searchParam.pageNum = val;
      this.getSceneList();
    },
    newOpenAdvDialog() {
      this.showNewDialog = true;
      this.coupons = [];
      this.NewdataPicker = [];
      this.newDate = {
        couponNo: "", //场景Id
        issueName: "", //场景名称
        scene: "", //场景类别
        startTime: "",
        endTime: "",
        status: true, //状态
        coupons: "", //绑定的优惠券为JSON格式[{name:yhy，id:1}]
      };
    },
    editTable(item) {
      this.showNewDialog = true;
      this.newDate = item;
      this.NewdataPicker = [];
      this.NewdataPicker[0] = item.startTime || "";
      this.NewdataPicker[1] = item.endTime || "";
      this.coupons = [];
      var Editcoupons = JSON.parse(item.coupons);
      var that = this;
      Editcoupons.forEach(function(item) {
        that.coupons.push(Number(item.id));
      });
    },
    // 提交更改
    async sureAddEdit() {
      if (!this.newDate.issueName) {
        this.$message({
          message: "请输入名称",
          type: "error",
        });
        return false;
      }
      if (!this.newDate.scene) {
        this.$message({
          message: "请选择场景",
          type: "error",
        });
        return false;
      }
      if (this.NewdataPicker && this.NewdataPicker.length > 0) {
        this.newDate.startTime = this.NewdataPicker[0] || "";
        this.newDate.endTime = this.NewdataPicker[1] || "";
      } else {
        this.$message({
          message: "请完善时间限制",
          type: "error",
        });
        return false;
      }
      if (this.coupons && this.coupons.length > 0) {
        var that = this;
        var NewCoupons = [];
        this.coupons.forEach(function(item) {
          var a = {};
          for (var i = 0; i < that.allCouponList.length; i++) {
            if (that.allCouponList[i].id == item) {
              a.id = item;
              a.name = that.allCouponList[i].name;
              NewCoupons.push(a);
            }
          }
        });
        this.newDate.coupons = JSON.stringify(NewCoupons);
      } else {
        this.$message({
          message: "请选择优惠券",
          type: "error",
        });
        return false;
      }
      // console.log(JSON.stringify(this.newDate))
      try {
        let res = await couponApi.addEditScene(this.newDate);
        if (res.code == "200") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.showNewDialog = false;
          this.getSceneList();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        handleError(error);
      }
    },
    changeSource(val) {
      // 修改产品类型 重新获取优惠券列表
      this.getAllCoupon();
    },
  },
  components: {
    // showTags,
    // SlickItem,
    // SlickList
  },
  directives: { handle: HandleDirective },
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'

.filter-search
  display flex
  flex-wrap wrap

  .el-date-editor
    max-width 360px
    margin-right 10px
    margin-bottom 10px

  .el-input
    max-width 140px
    margin-right 10px
    margin-bottom 10px

.option-button
  position relative
  padding-right 50px

  .edit-btn
    position absolute
    right 4px

.form-upload-excel
  display inline-block
  margin-left 10px

.table-container
  margin-top 20px

  .el-pagination
    margin-top 20px

.el-dialog__body
  .el-form
    height 400px
    padding 10px
    overflow-y scroll

    .el-select
      width 100%

  .el-input-number
    margin-left 10px

  .preview
    display flex
    justify-content center
    align-items center
    padding 10px
    margin-top 6px
    border 1px dashed #999
    border-radius 6px

    img
      cursor pointer
      max-width 300px

.dialog-img
  display flex
  justify-content center
  align-items center
  padding 10px

  img
    max-width 600px
</style>
